import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import StatsCard from "../../../Components/UI/staticsCard";
import StoreIcon from "../../../Components/Common/svg/storeicon";
import UserIcon from "../../../Components/Common/svg/userIcon";
import HeaderBar from "../../../Components/UI/headerbar";
import PosTab from "../../../Components/stores/PosTab";
import { getStoresStats } from "../../../MyApi/stores";
import ScreenIcon from "../../../Components/Common/svg/screen";
import { useLocation, useSearchParams } from "react-router-dom";

const PosPage = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState( "pos");
  const [searchParams] = useSearchParams()   
  const pageParam = searchParams.get("page") || 1;
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({
    store_id: "",
    role_id: "",
    status: "",
    search: "",
  });
 console.log('pageParam', pageParam)
  useEffect(()=>{
    setCurrentPage(Number(pageParam))
  },[pageParam])
  const statsQuery = useQuery("getStatsData", getStoresStats);
  const statsData = statsQuery?.data?.data || {};

  const storeStats = [
    {
      title: "أصحاب المتاجر والموظفين",
      count: statsData.vendor_count,
      color: "#FFCC03",
      icon: <UserIcon />,
      bgIcon: "#E6F3EF",
    },
    {
      title: "المتاجر",
      count: statsData.store_count,
      color: "#1DBF73",
      icon: <StoreIcon />,
      bgIcon: "#E6F3EF",
    },
    {
      title: "نقاط البيع",
      count: statsData.pos_count,
      color: "#FF3B30",
      icon: <ScreenIcon/>,
      bgIcon: "#FDEAE9",
    },
  ];

  const onTabChange = (key) => {
    setActiveTab(key);
  };

console.log('location.state?.tab)', location.state?.tab )
  useEffect(() => {
  if (location.state?.tab) {
    setActiveTab(location.state.tab);
  }
}, [location.state]);
  return (
    <div className="container-fluid">
      <HeaderBar title={"المتجر"} content={"جميع المتاجر المتاحة علي دايم"} dataTestId="stores-header" page={location.state?.page}/>
      <div className="row g-3">
        {storeStats.map((stat, index) => (
          <div className="col-md-4" key={index}>
            <StatsCard {...stat} isLoading={statsQuery.isLoading} />
          </div>
        ))}
      </div>
        <PosTab
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          filters={filters}
          setFilters={setFilters}
        />
    </div>
  );
};

export default PosPage;
